<p>
  {{
    'sharedModule.bkgVehicleDialogUmcSelectors.addMakeModelSubtitle' | translate
  }}
</p>

<form
  *ngIf="!createNewVehicle"
  [formGroup]="umcForm"
  class="modal__section form-compact"
  errorTailor
>
  <div class="form-group">
    <label class="text-start">
      {{ 'sharedModule.bkgVehicleDialogUmcSelectors.make' | translate }}
    </label>
    <ng-select
      #selectMakeIdSelect
      (change)="selectMakeIdSelect.blur()"
      formControlName="makeIdSelect"
      id="makeIdSelect"
      [clearable]="false"
      [searchable]="true"
      [appendTo]="showInBody"
      placeholder="{{
        'sharedModule.bkgVehicleDialogUmcSelectors.selectMake' | translate
      }}"
      controlErrorsClass="info-field--warning"
    >
      <ng-option *ngFor="let mk of makes" [value]="mk.id">{{
        mk.make_description
      }}</ng-option>
    </ng-select>
  </div>
  <div class="form-group">
    <label class="text-start">
      {{ 'sharedModule.bkgVehicleDialogUmcSelectors.model' | translate }}
      <div
        *ngIf="loadingModels"
        class="blue-spinner__small loading__spinner"
      ></div>
    </label>
    <ng-select
      #selectModelIdSelect
      (change)="selectModelIdSelect.blur()"
      formControlName="modelIdSelect"
      id="modelIdSelect"
      [clearable]="false"
      [searchable]="true"
      [appendTo]="showInBody"
      placeholder="{{
        'sharedModule.bkgVehicleDialogUmcSelectors.selectModel' | translate
      }}"
      controlErrorsClass="info-field--warning"
    >
      <ng-option *ngFor="let md of filterModels" [value]="md.id">{{
        md.friendlyName
      }}</ng-option>
    </ng-select>
  </div>
  <div *ngIf="modelYears?.length > 1" class="form-group">
    <label class="text-start">
      {{ 'sharedModule.bkgVehicleDialogUmcSelectors.year' | translate }}:
    </label>
    <ng-select
      #selectModelYearIdSelect
      (change)="selectModelYearIdSelect.blur()"
      formControlName="modelYearIdSelect"
      id="modelYearIdSelect"
      [clearable]="false"
      [searchable]="false"
      [appendTo]="showInBody"
      placeholder="{{
        'sharedModule.bkgVehicleDialogUmcSelectors.year' | translate
      }}"
      controlErrorsClass="info-field--warning"
    >
      <ng-option *ngFor="let my of modelYears" [value]="my.id">{{
        my.year
      }}</ng-option>
    </ng-select>
  </div>
  <div class="form-group">
    <label class="text-start">
      {{ 'sharedModule.bkgVehicleDialogUmcSelectors.propulsion' | translate }}
      <div
        *ngIf="loadingPropulsion"
        class="blue-spinner__small loading__spinner"
      ></div>
    </label>
    <ng-select
      #selectPropulsionSelect
      (change)="selectPropulsionSelect.blur()"
      formControlName="propulsionSelect"
      id="propulsionSelect"
      [clearable]="false"
      [searchable]="false"
      [appendTo]="showInBody"
      placeholder="{{
        'sharedModule.bkgVehicleDialogUmcSelectors.selectPropulsion' | translate
      }}"
      controlErrorsClass="info-field--warning"
    >
      <ng-option *ngFor="let p of propulsions" [value]="p.propulsion_code">{{
        p.propulsion
      }}</ng-option>
    </ng-select>
  </div>
  <p *ngIf="!addMoreInfoUmc">
    <a class="link" (click)="onClickNotFoundCarOption()">
      {{
        'sharedModule.bkgVehicleDialogUmcSelectors.notFoundCarOption'
          | translate
      }}</a
    >
  </p>

  <button
    *ngIf="!addMoreInfoUmc"
    class="btn-primary btn-large is-block"
    [class.disabled]="isButtonDisabled"
    (click)="sendUmcForm()"
  >
    {{ 'sharedModule.bkgVehicleDialogUmcSelectors.agree' | translate }}
  </button>
</form>

<form
  *ngIf="createNewVehicle"
  [formGroup]="vehicleDataForm"
  class="modal__section"
  errorTailor
>
  <label *ngIf="plateNotFounded"
    >{{ 'sharedModule.bkgSummaryReservation.plate' | translate }}
    {{ plateNotFounded }}</label
  >
  <div class="form-group" [class.success]="isValidField('brand')">
    <label for="user-brand" class="sr-only">{{
      'sharedModule.bkgVehicleDialogNotFoundForm.make' | translate
    }}</label>
    <input
      type="text"
      id="user-brand"
      formControlName="brand"
      placeholder="{{
        'sharedModule.bkgVehicleDialogNotFoundForm.make' | translate
      }}"
      [class.warning]="hasErrors('brand')"
      controlErrorsClass="info-field"
      [attr.disabled]="addMoreInfoUmc"
    />
  </div>
  <div class="form-group" [class.success]="isValidField('model')">
    <label for="user-model" class="sr-only">{{
      'sharedModule.bkgVehicleDialogNotFoundForm.model' | translate
    }}</label>
    <input
      type="text"
      id="user-model"
      formControlName="model"
      placeholder="{{
        'sharedModule.bkgVehicleDialogNotFoundForm.model' | translate
      }}"
      [class.warning]="hasErrors('model')"
      controlErrorsClass="info-field"
      [attr.disabled]="addMoreInfoUmc"
    />
  </div>
  <div class="form-group" [class.success]="isValidField('color')">
    <label for="user-color" class="sr-only">{{
      'sharedModule.bkgVehicleDialogNotFoundForm.color' | translate
    }}</label>
    <input
      type="text"
      id="user-color"
      formControlName="color"
      placeholder="{{
        'sharedModule.bkgVehicleDialogNotFoundForm.color' | translate
      }}"
      [class.warning]="hasErrors('color')"
      controlErrorsClass="info-field"
      [attr.disabled]="addMoreInfoUmc"
    />
  </div>
  <button
    *ngIf="!addMoreInfoUmc"
    class="btn-primary btn-large is-block"
    [class.disabled]="isButtonDataDisabled"
    (click)="sendVehicleDataForm()"
  >
    {{ 'sharedModule.bkgVehicleDialogUmcSelectors.agree' | translate }}
  </button>
</form>
